/**
 * Join class names, dropping anything falsy.
 *
 * Hand written rather than pulled in, because this is the whole of what the
 * application needs from a class name library and the dependency would be
 * larger than the function.
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...values: readonly ClassValue[]): string {
  let out = '';
  for (const value of values) {
    if (!value) continue;
    out = out ? `${out} ${value}` : String(value);
  }
  return out;
}
